import React from 'react';
import PropTypes from 'prop-types';

const CustomStepProgress = ({ steps, currentStep, onStepClick, className = '' }) => {
  const handleStepClick = (stepNumber) => {
    if (onStepClick) {
      onStepClick(stepNumber); 
    }
  };

  return (
    <div className={`flex items-center justify-center mb-8 mt-2 ${className}`}>
      <div className="flex items-center justify-between w-full max-w-2xl relative">
        {steps.map((step, index) => (
          <div
            key={step.id || index}
            onClick={() => handleStepClick(index + 1)}
            className="flex cursor-pointer flex-col items-center z-10 w-1/3"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleStepClick(index + 1)}
            aria-label={`Step ${index + 1}: ${step.label}`}
          >
            <div
              className={`w-9 h-9 border-2 rounded-full flex items-center justify-center font-bold mb-2 transition-all duration-500 ease-in-out transform ${
                currentStep > index
                  ? 'bg-white border-customGreen'
                  : 'bg-gray-300 border-gray-300'
              } ${currentStep === index + 1 ? 'scale-110' : ''}`}
            >
              <div
                className={`h-6 w-6 rounded-full flex items-center justify-center text-[16px] transition-all duration-500 ${
                  currentStep > index
                    ? 'bg-customGreen text-white'
                    : 'bg-gray-300 text-gray-700'
                }`}
              >
                {currentStep > index ? (
                  <span className="animate-fadeIn">✓</span>
                ) : (
                  <div className='bg-white w-6 h-6 rounded-full'></div>
                )}
              </div>
            </div>
            <span
              className={`text-sm font-medium text-center transition-all duration-300 ${
                currentStep === index + 1 ? 'text-customGreen' : 'text-gray-700'
              }`}
            >
              {step.label}
            </span>
          </div>
        ))}

        {/* Connector with animation */}
        <div className="absolute top-4 left-[16%] w-[68%] h-0.5 bg-gray-300 z-0">
          <div
            className="h-0.5 bg-customGreen transition-all duration-500 ease-in-out"
            style={{
              width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
            }}
          />
        </div>
      </div>
    </div>
  );
};



export default CustomStepProgress;